import React from "react";
import { useDispatch } from "react-redux";
import { setProjectMemoryWrites, setTitleMemoryWrites, updateProjectMemoryPenalties, updateTitleMemoryPenalties } from "../../../redux/ducks/memory";

const SetMemoryWrite = props => {

    const dispatch = useDispatch();

    return (
        <button className={"button button--warm " + (props.memories.length > 0 ? "" : "button--disabled")} onClick={e => {
            let write = prompt("Write 0/1");
            if (write == null) return;
            if (write != "0" && write != "1") {
                alert("Value must be 1 or 0.");
                return;
            }

            if (props.titleID != undefined) {
                dispatch(setTitleMemoryWrites({ write, memoryIDs: props.memories, titleID: props.titleID }));
            } else if (props.projectID != undefined) {
                dispatch(setProjectMemoryWrites({ write, memoryIDs: props.memories, projectID: props.projectID }));
            }
        }}>Set Write</button>
    )
}

export default SetMemoryWrite;